import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import type { SpaceType } from "@circle-react/types/Space";
import { RadioGroup } from "@circleco/compass/components/RadioGroup";
import { Typography } from "@circleco/compass/components/Typography";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { SPACE_TYPE_FORM_ID } from "../constants";
import { buildSpaceTypeOptions } from "../utils";

interface SpaceTypeStepProps {
  initialValue: SpaceType;
  onSelect: (type: SpaceType) => void;
}

export const SpaceTypeStep = ({
  initialValue,
  onSelect,
}: SpaceTypeStepProps) => {
  const { currentCommunity } = usePunditUserContext();
  const [value, setValue] = useState<SpaceType>(initialValue);
  const isMobile = useIsMobile();

  const options = buildSpaceTypeOptions({
    isCoursesEnabled: Boolean(currentCommunity?.courses_feature_flag_enabled),
  }).map(option => ({
    value: option.value,
    icon: option.icon,
    label: option.label,
    description: (
      <Typography
        variant="body-sm"
        component="span"
        color="secondary"
        dangerouslySetInnerHTML={{ __html: t(option.descriptionKey) }}
      />
    ),
  }));

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSelect(value);
  };

  return (
    <form id={SPACE_TYPE_FORM_ID} onSubmit={handleSubmit}>
      <RadioGroup
        legend={t("spaces.form.create.space_types.choose_type")}
        legendProps={{ className: "sr-only" }}
        name="post_type"
        variant="option-cards"
        optionCardLayout={isMobile ? "horizontal" : "vertical"}
        optionCardContentLayout={isMobile ? "horizontal" : undefined}
        optionCardColumns={isMobile ? 1 : 3}
        value={value}
        onValueChange={next => setValue(next as SpaceType)}
        options={options}
      />
    </form>
  );
};
